import { useState } from 'react'
import { useInView } from 'react-intersection-observer'
import RichText from 'components/common/richText'
import SumiCircle from 'images/Circle Illustration 2.png'
import { LinkButton } from 'components/common/typography'
import UnderlineList from 'components/common/underlineList'
import SpringDecoration from 'images/Spring Illustration.png'
import SummerDecoration from 'images/Summer Illustration.png'
import AutumnDecoration from 'images/Autumn Illustration.png'
import WinterDecoration from 'images/Winter Illustration.png'
import { Section, ConditionalDiv } from 'components/common/common_styles'
import { MainContainer, TitleContainer, ImageContainer, ImageDecoration, SeasonImage, MaskPath, MobileListContainer } from './seasons_styles'

const Seasons = ({ data }) => {
  const [seasonIndex, setSeasonIndex] = useState(0)
  const [circleRef, circleInView] = useInView()

  const seasonData = [
    {
      title: data.primary.spring_title,
      body: data.primary.spring_copy,
      image: data.primary.spring_image,
      decoration: SpringDecoration,
      key: 'spring'
    },
    {
      title: data.primary.summer_title,
      body: data.primary.summer_copy,
      image: data.primary.summer_image,
      decoration: SummerDecoration,
      key: 'summer'
    },
    {
      title: data.primary.autumn_title,
      body: data.primary.autumn_copy,
      image: data.primary.autumn_image,
      decoration: AutumnDecoration,
      key: 'autumn'
    },
    {
      title: data.primary.winter_title,
      body: data.primary.winter_copy,
      image: data.primary.winter_image,
      decoration: WinterDecoration,
      key: 'winter'
    }
  ]

  return (
    <Section washi>
      <MainContainer padTop={[4, 2]} padLeft={[true, false]}>
        <TitleContainer title={data.primary.title}>
          <RichText data={data.primary.copy} />
          {data.primary.button_link && data.primary.button_title &&
            <LinkButton link={data.primary.button_link}>{data.primary.button_title}</LinkButton>
          }
          <ConditionalDiv desktopOnly>
            <UnderlineList data={seasonData} currentIndex={seasonIndex} setCurrentIndex={setSeasonIndex} />
          </ConditionalDiv>
        </TitleContainer>
        <ImageContainer>
          <ImageDecoration src={seasonData[seasonIndex].decoration} alt='' />
          <SeasonImage data={seasonData[seasonIndex].image} />
          <svg viewBox='0 0 1400 1400' ref={circleRef}>
            <defs>
              <mask id='imageMask'>
                <MaskPath
                  strokeWidth='180'
                  stroke='white'
                  fill='none'
                  d='M 1086 1160 A 600 600 50 1 1 1101 1146'
                  strokeDasharray='3770 3770'
                  strokeDashoffset='3770'
                  strokeLinecap='round'
                  play={circleInView}
                />
              </mask>
            </defs>
            <image href={SumiCircle} width='1400' height='1400' mask='url(#imageMask)' />
          </svg>
        </ImageContainer>
        <ConditionalDiv mobileOnly>
          <MobileListContainer>
            <UnderlineList data={seasonData} currentIndex={seasonIndex} setCurrentIndex={setSeasonIndex} />
          </MobileListContainer>
        </ConditionalDiv>
      </MainContainer>
    </Section>
  )
}

export default Seasons
